// src/redux/Kyc/kycSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getKycListRequest,
  getKycListSuccess,
  getKycListFailure,
  getKycHistoryRequest,
  getKycHistorySuccess,
  getKycHistoryFailure,
  approveRejectDocRequest,
  approveRejectDocSuccess,
  approveRejectDocFailure,
  revokeKycStatusRequest,
  revokeKycStatusSuccess,
  revokeKycStatusFailure,
} from "./kycSlice";
import { toast } from "react-toastify";

// GET KYC LIST
function* fetchKycList(action) {
  try {
    const payload = action.payload || {};

    const response = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/kyc/kycList`, {
        params: payload, // ✅ pass as query params
      })
    );

    yield put(getKycListSuccess(response.data));
  } catch (error) {
    yield put(getKycListFailure(error.message));
    toast.error("Failed to fetch KYC list");
  }
}

// GET KYC HISTORY
function* fetchKycHistory(action) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/kyc/getKycHistory?id=${action.payload}`
    );
    yield put(getKycHistorySuccess(response.data.data));
  } catch (error) {
    yield put(getKycHistoryFailure());
    toast.error("Failed to fetch KYC history");
  }
}

// APPROVE/REJECT DOC
function* handleApproveRejectDoc(action) {
  try {
    yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/kyc/approveRejectDoc`,
        action.payload
      )
    );
    yield put(approveRejectDocSuccess());
    toast.success("KYC document status updated");
    // Refetch updated KYC list
    yield put(getKycListRequest());
  } catch (error) {
    yield put(approveRejectDocFailure(error.message));
    toast.error("Failed to update KYC document status");
  }
}

// REVOKE KYC STATUS
function* handleRevokeKycStatus(action) {
  try {
    yield call(() =>
      axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/kyc/revokeKycStatus`,
        action.payload
      )
    );
    yield put(revokeKycStatusSuccess());
    toast.success("KYC status revoked successfully");

    // Refetch updated KYC list if needed
    yield put(getKycListRequest());
  } catch (error) {
    yield put(revokeKycStatusFailure(error.message));
    toast.error("Failed to revoke KYC status");
  }
}

export function* kycSaga() {
  yield takeLatest(getKycListRequest.type, fetchKycList);
  yield takeLatest(getKycHistoryRequest.type, fetchKycHistory);
  yield takeLatest(approveRejectDocRequest.type, handleApproveRejectDoc);
  yield takeLatest(revokeKycStatusRequest.type, handleRevokeKycStatus);
}
